<script>
function broadcast (componentName, eventName, params) {
  this.$children.map(child => {
    const name = child.$options.name
    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params))
    } else {
      broadcast.apply(child, [componentName, eventName].concat([params]))
    }
  })
}

export default {
  name: 'Menu',
  data () {
    return {
      currentActiveName: this.activeName
    }
  },
  provide () {
    return {
      rootMenu: this
    }
  },
  props: {
    activeName: {
      type: String,
      default: ''
    },
    uniqueOpened: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.$on('item-click', this.handleItemClick)
    this.updateActiveName()
  },
  watch: {
    currentActiveName (val) {
      this.updateActiveName()
    }
  },
  methods: {
    broadcast (componentName, eventName, params) {
      broadcast.call(this, componentName, eventName, params)
    },
    updateActiveName () {
      this.broadcast('Submenu', 'on-update-active-name', false)
      this.broadcast('MenuItem', 'on-update-active-name', this.currentActiveName)
    },
    handleItemClick (item) {
      this.currentActiveName = item.name
      this.updateActiveName()
    }
  },
  render () {
    return <ul class='re-menu'>{this.$slots.default}</ul>
  }
}
</script>



// WEBPACK FOOTER //
// src/package/Menu/menu.vue